import { useState } from "react"

import { Pagination } from "@/components/ui/pagination"

export function PaginationPreviewRoute(): JSX.Element {
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Pagination</h1>
      </header>

      <div className="rounded-lg border border-border bg-surface shadow-e1">
        <div className="grid h-64 place-items-center text-body text-text-3">
          Table body would render here
        </div>
        <Pagination
          className="border-t border-border"
          page={page}
          pageSize={pageSize}
          total={137}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          pageSizes={[10, 25, 50, 100]}
        />
      </div>
    </div>
  )
}
